import React from "react";
import MuiAccordionSummary, {
  AccordionSummaryProps as MuiAccordionSummaryProps,
} from "@mui/material/AccordionSummary";
import { ChevronDownIcon } from "@heroicons/react/24/outline";

type AccordionSummaryProps = Pick<
  MuiAccordionSummaryProps,
  "aria-controls" | "children" | "id"
>;

export const AccordionSummary: React.FC<AccordionSummaryProps> = ({
  children,
  ...props
}) => {
  return (
    <MuiAccordionSummary
      expandIcon={<ChevronDownIcon className="w-5 h-5" />}
      className="font-medium text-md"
      sx={{
        backgroundColor: "transparent",
        borderBottom: "1px solid #e0e0e0",
        padding: "16px 0",
        minHeight: "unset",
        "&.Mui-expanded": {
          minHeight: "unset",
        },
        "& .MuiAccordionSummary-content": {
          margin: "0",
          "&.Mui-expanded": {
            margin: "0",
          },
        },
      }}
      {...props}
    >
      <span className="text-gray-900">{children}</span>
    </MuiAccordionSummary>
  );
};
